module.exports = __webpack_public_path__ + "img/icon_tick_select.93921bb5.png";